
const Galeri = resolve => {
    require.ensure(['../views/apps/galeri/Galeri'], () => {
        resolve(require('../views/apps/galeri/Galeri'))
    })
};
const GaleriTanimla = resolve => {
    require.ensure(['../views/apps/galeri/GaleriTanimla'], () => {
        resolve(require('../views/apps/galeri/GaleriTanimla'))
    })
};
const GaleriListe = resolve => {
    require.ensure(['../views/apps/galeri/GaleriListe'], () => {
        resolve(require('../views/apps/galeri/GaleriListe'))
    })
};



import layouts from '../layout'

export default {
    path: '/galeri',
    name: 'galeri',
    component: Galeri,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: 'tanimlama',
            name: 'galeritanimlama',
            component: GaleriTanimla,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'liste',
            name: 'galeriliste',
            component: GaleriListe,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
    ],

}
